import { i18nObject } from './util.object.mjs';
// --------------------------------------------------------------------------------------------------------------------
// implementation -----------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------
// async --------------------------------------------------------------------------------------------------------------
export const initI18nObjectLoaderAsync = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = {};
    return async (locale, getTranslationForLocale, formattersInitializer) => cache[locale] ||
        (cache[locale] = i18nObject(locale, await getTranslationForLocale(locale), await formattersInitializer(locale)));
};
// @deprecated
export const i18nObjectLoaderAsync = initI18nObjectLoaderAsync();
// sync ---------------------------------------------------------------------------------------------------------------
export const initI18nObjectLoader = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = {};
    return (locale, getTranslationForLocale, formattersInitializer) => cache[locale] ||
        (cache[locale] = i18nObject(locale, getTranslationForLocale(locale), formattersInitializer(locale)));
};
// @deprecated
export const i18nObjectLoader = initI18nObjectLoader();
//# sourceMappingURL=util.loader.js.map